// Module Import
//---------------------------------
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { brandOrange, brandSoftGrey } from '../../../assets/consts/color'
import { primaryFont, secondaryFont } from '../../../assets/consts/fonts'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const FieldWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};

  &[aria-required='true']::after {
    position: absolute;
    top: 0;
    left: 16px;
    content: '*';
    color: red;
  }
`

const FieldLabel = styled.label`
  color: ${brandSoftGrey};
  font-family: ${primaryFont};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 87.5% */
  height: 0;
  visibility: hidden;
  width: 100%;
`

export const InputField = styled.textarea`
  display: flex;
  padding: 16px;
  background-color: transparent;
  align-self: stretch;
  border: 0;
  border-bottom: 2px solid ${brandSoftGrey};
  transition: all 0.25s;
  color: ${brandSoftGrey};

  font-family: ${secondaryFont};
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 25px; /* 20px */
  width: 100%;

  resize: none;

  &:focus {
    outline: none;
    border-bottom: 2px solid ${brandOrange};
  }

  &:hover {
    border-bottom: 2px solid ${brandOrange};
  }
`

// Component Export
//---------------------------------
export default function TextareaField({
  labelText,
  labelFor,
  placeholderText,
  fieldId,
  fieldName,
  required,
  fullWidth,
  ...prop
}) {
  return (
    <FieldWrapper aria-required={required} fullWidth={fullWidth}>
      <FieldLabel htmlFor={labelFor}>{labelText}</FieldLabel>
      <InputField id={fieldId} name={fieldName} placeholder={placeholderText} {...prop} />
    </FieldWrapper>
  )
}

TextareaField.propTypes = {
  LabelText: PropTypes.string.isRequired,
  labelFor: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
  fieldId: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
}
